<template>
  <div id="app">
    <router-view v-show="!scanDialogVisable"/>

    <ScanDilalog
      v-show="scanDialogVisable"
      ref="ScanDialog"
    ></ScanDilalog>
  </div>
</template>

<script>
import eventBus from './util/eventBus.js'

var app = {
  name: 'App',
  data() {
      return {
        scanDialogVisable:false
      };
  },
  mounted(){
    var that = this;
    eventBus.$on('scanDialogOpen',function (callback) {
      that.scanDialogVisable = true;

      that.$nextTick(async o=>{
        var result = await that.$refs.ScanDialog.open();
        that.scanDialogVisable = false;
        callback(result);
      });
    })
    eventBus.$on('scanDialogQuit',function () {
      that.scanDialogVisable = false;
    })
  },
  methods:{
  }
}

export default app
</script>

<style>
body {
  font-size: 16px;
  background-color: #f8f8f8;
  -webkit-font-smoothing: antialiased;
}
</style>


